module.exports = __webpack_public_path__ + "dict/img/img.146655c9.jpg";